import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { DELETE_ASYNC_JOB } from "../types";
import {
  deleteAsyncJobPending,
  deleteAsyncJobFulfilled,
  deleteAsyncJobRejected,
} from "../actions";

import { sendApiRequest, notifyError, notifySuccess } from "../../../actions";

import { DELETE_ASYNC_JOBS_MESSAGES } from "../constants/organizationMessages";
import generateError from "../../../utilities/generateError";

const createPayload = (id) => ({
  method: "delete",
  url: "asyncjobs/delete/" + id,
  onSuccess: [
    deleteAsyncJobFulfilled,
    () => notifySuccess(DELETE_ASYNC_JOBS_MESSAGES.SUCCESS),
  ],
  onError: [
    deleteAsyncJobRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: { id },
});

const meta = {
  api: "ajaxApi",
};

const deleteAsyncJobEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_ASYNC_JOB.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      return merge(
        of(deleteAsyncJobPending()),
        of(sendApiRequest(createPayload(payload), meta))
      );
    })
  );

export default deleteAsyncJobEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/deleteAsyncJobEpic.js